import {
    APPLY_LEASE_CONTRACT_FIELDS,
    APPLY_LEASE_CONTRACT_FIELDS_FAILURE,
    REQUEST_LEASE_CONTRACT_FIELDS
} from '../actionTypes/leaseContractingFieldsActionTypes';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { type ReduxNext, type ReduxStore } from '@makemydeal/dr-shared-store';
import type { StateTree } from '@makemydeal/dr-dash-types';
import * as paymentSelectors from '../selectors/payment';

import * as leaseContractingFieldsActionCreators from '../actions/leaseContractingFieldsActionCreators';
import { PAYMENT_RECEIVED } from '../actionTypes/deskingActionTypes';

export const middleware = (store: ReduxStore<StateTree>) => (next: ReduxNext) => async (action: AnyFSA) => {
    next(action);
    const state = store.getState();

    switch (action.type) {
        case PAYMENT_RECEIVED: {
            if (action.payload.actionForPayment === APPLY_LEASE_CONTRACT_FIELDS) {
                if (paymentSelectors.getIsError(state)) {
                    const messages = [{ message: 'Error applying lease contract fields.' }];
                    store.dispatch(leaseContractingFieldsActionCreators.applyLeaseContractingError(action, messages));
                } else {
                    store.dispatch(leaseContractingFieldsActionCreators.applyLeaseContractingFieldsSuccess(action));
                }
            }
            break;
        }

        case REQUEST_LEASE_CONTRACT_FIELDS: {
            store.dispatch(leaseContractingFieldsActionCreators.applyLeaseContractFields(action));
            break;
        }
        case APPLY_LEASE_CONTRACT_FIELDS_FAILURE: {
            store.dispatch(leaseContractingFieldsActionCreators.applyLeaseContractingError(action));
            break;
        }
        default:
            break;
    }
};
